module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus",
      "size": "mini"
    },
    on: {
      "click": _vm.handleNew
    }
  }, [_vm._v("新增规格")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "规格名称",
      "size": "mini"
    },
    on: {
      "change": _vm.brandSearch
    },
    model: {
      value: (_vm.params.attribute_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "attribute_name", $$v)
      },
      expression: "params.attribute_name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.brandSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 170,
      "element-loading-text": "数据加载中",
      "default-sort": {
        prop: 'bind_date',
        order: 'descending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _vm._l((props.row.attribute_values.list), function(item, index) {
          return _c('span', {
            key: index,
            staticClass: "sku-value"
          }, [(item.image_url) ? _c('img', {
            staticClass: "sku-img",
            attrs: {
              "src": item.image_url
            }
          }) : _vm._e(), _vm._v(_vm._s(item.attribute_value))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(JSON.parse(props.row.is_image) ? '图片' : '文字') + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "attribute_name",
      "label": "规格名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "attribute_memo",
      "label": "规格备注"
    }
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  }), _vm._v(" "), _c('sideBar', {
    attrs: {
      "visible": _vm.show_sideBar,
      "title": '新增规格'
    },
    on: {
      "update:visible": function($event) {
        _vm.show_sideBar = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "规格名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.attribute_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "attribute_name", $$v)
      },
      expression: "form.attribute_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规格备注"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.attribute_memo),
      callback: function($$v) {
        _vm.$set(_vm.form, "attribute_memo", $$v)
      },
      expression: "form.attribute_memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规格类型"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.is_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_image", $$v)
      },
      expression: "form.is_image"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("文字")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("图片")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规格值"
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._l((_vm.form.attribute_values), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "view-flex view-flex-middle key-item"
    }, [(_vm.form.is_image) ? _c('div', {
      staticClass: "upload-box",
      on: {
        "click": function($event) {
          return _vm.handleImgPicker(index)
        }
      }
    }, [(item.image_url) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.image_url
      }
    }) : _c('i', {
      staticClass: "iconfont icon-camera avatar-uploader-icon"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "view-flex-item",
      class: _vm.form.is_image ? 'content-h-padded' : 'content-padded-right'
    }, [_c('el-input', {
      attrs: {
        "placeholder": "规格值名称"
      },
      model: {
        value: (item.attribute_value),
        callback: function($$v) {
          _vm.$set(item, "attribute_value", $$v)
        },
        expression: "item.attribute_value"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-trash-alt1",
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    })])
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default",
      "size": "small"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("添加规格值")])], 2), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42a130ce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42a130ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/attributes/attributes.vue
// module id = 2669
// module chunks = 0